import draftToHtml from 'draftjs-to-html';
import parse from 'html-react-parser';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { LoadingImg } from '../_components';
import { notesService } from '../_services/notes.service';
import { isEnglish } from '../_helpers';
import './note.css';
export const NoteSingleView = () => {
  const location = useLocation();
  const { id } = location.state;
  const [isLoading, setIsLoading] = useState(false);
  const [noteData, setNoteData] = useState({});

  useEffect(() => {
    if (id) {
      getNoteById(id);
    }
  }, [id]);

  const getNoteById = async (_id) => {
    try {
      setIsLoading(true);

      const response = await notesService.notesList({ _id });
      if (response.data.rows.length) {
        setNoteData(response.data.rows[0]);
      }
    } catch (err) {
      console.log(err, 'this is err');
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div
      className={
        'container mt-5 d-flex flex-column ' + (isEnglish(noteData?.title) ? 'ltrtext' : 'rtltext')
      }
      dir={isEnglish(noteData?.title) ? 'ltr' : 'rtl'}
    >
      {!isLoading && (
        <div style={{ display: 'contents' }}>
          <div
            className={'notehead ' + (isEnglish(noteData.title) ? 'ltrtext' : 'rtltext')}
          >
            {noteData.title}
          </div>
          <div
            className={'notetext ' + (isEnglish(noteData?.note) ? 'ltrtext' : 'rtltext')}
          >
            {parse(draftToHtml(noteData?.note), {
              decodeEntities: false,
            })}

            <img src='/Group.png' alt='' className='notebgicon' />
          </div>
        </div>
      )}
      {isLoading && <LoadingImg />}
    </div>
  );
};
